import moment from 'moment';
import formatDate from 'clevertap/formatDate';
import formatPhoneNumber from 'clevertap/formatPhoneNumber';
import pushClevertapEvent from 'clevertap/pushClevertapEvent';

import { find, get } from 'lodash';

export function setUserProfile({ profile, businessTypes, businessCategories }) {
  const businessTypeName = get(
    find(businessTypes, t => t.id === profile.business.business_type_id),
    'name',
    ''
  );
  const businessCategoryName = get(
    find(
      businessCategories,
      c => c.id === profile.business.business_category_id
    ),
    'name',
    ''
  );

  let accountLevel = null;
  if (profile.is_owner) {
    accountLevel = 'Owner';
  } else if (profile.is_manager) {
    accountLevel = 'Administrator';
  } else {
    accountLevel = 'Employee';
  }

  const userProfile = {
    Name: `${profile.first_name} ${profile.last_name}`,
    Identity: profile.id,
    Email: profile.email,
    'First Name': profile.first_name,
    'Last Name': profile.last_name,
    Created: formatDate(profile.created_at),
    'Last Login': formatDate(moment()),
    Phone: formatPhoneNumber(profile.phone),
    'Business Name': profile.business.name,
    'Business Type ID': profile.business.business_type_id,
    'Business Category ID': profile.business.business_category_id,
    'Business Address': profile.business.address,
    'Business City': profile.business.city,
    'Business State': profile.business.province,
    'Business ZIP': profile.business.zip,

    // This field is added specifically to allow user targetting with email.
    // Somehow Clevertap doesn't support using the `Email` field above.
    'User Email': profile.email,

    'Phone Number': formatPhoneNumber(profile.phone),
    Expired: !profile.business.expired_at
      ? ''
      : formatDate(profile.business.expired_at),
    'Days to Expire': !profile.business.expired_at
      ? 0
      : moment(profile.business.expired_at).diff(moment(), 'days'),
    'Business Type Name': businessTypeName,
    'Business Category Name': businessCategoryName,
    'Subscription Plan':
      profile.business.current_plan === 12
        ? 'Annual'
        : profile.business.current_plan === 1
        ? 'Monthly'
        : '',
    'Account Level': accountLevel,
  };

  const {
    is_mokapos_user: isMokaPosUser,
    is_trial: isTrial,
    has_expired: hasExpired,
  } = profile.business;
  if (isMokaPosUser === undefined) {
    // Before release of MokaPay Billing Separation, `isMokaPosUser` not returned by API
    // Delete this block if necessary
    if (isTrial) {
      userProfile['Paid Status'] = 'Trial';
    } else if (hasExpired) {
      userProfile['Paid Status'] = 'Churn';
    } else {
      userProfile['Paid Status'] = 'Paid';
    }
  } else if (isMokaPosUser) {
    // After release of MokaPay Billing Separation, it can be `true` or `false`
    if (isTrial) {
      userProfile['Paid Status'] = 'Trial';
    } else if (hasExpired) {
      userProfile['Paid Status'] = 'Churn';
    } else {
      userProfile['Paid Status'] = 'Paid';
    }
  } else {
    userProfile['Paid Status'] = 'Free';
  }

  if (profile.is_owner) {
    userProfile['Active Subscription'] = profile.already_subscribed;
    if (profile.business.is_trial) {
      userProfile['Paid Outlet Count'] = 0;
    } else {
      userProfile['Paid Outlet Count'] = profile.business.outlet_slot;
    }
  }
  clevertap.onUserLogin.push({ Site: userProfile });
}

export function login({ profile, role }) {
  pushClevertapEvent('Login', {
    'User ID': profile.id,
    'Active Subscription': profile.already_subscribed,
    'Is Business Owner': profile.is_owner,
    Email: profile.email,
    Role: role ? role.name : '',
  });
}
